module.exports = __webpack_public_path__ + "static/media/marnie-win.97464fa0.png";